// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLink_root__2J-Om"};